import React from 'react';
import * as mime from 'mime-types';
import Lottie from "lottie-react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import LoadingBox from './LoadingBox';
import AlertBox from './AlertBox';

import {uploadAttachment, uploadAttachmentWithoutLink} from '../../networking/NetworkingAttachments';
import uploadAnimation from '../../animations/upload-files.json';

import AppContext from '../../AppContext';

import '../../css/attachments-form.scss';
export default class AttachmentsForm extends React.Component {
    constructor(props){
        super(props);
        this.fileInput = React.createRef();
        this.handleUploadFile = this.handleUploadFile.bind(this);
    }

    state = {
        description: '',
        loading: false,
        showAlert: false,
        alertTitle: '',
        alertMessage:''
    }

    componentDidMount(){

    }

    componentDidUpdate(prevProps){

    }

    getDescriptionValue(event){
        this.setState({description: event.target.value});
    }

    handleUploadFile(event) {
        event.preventDefault();
        var file = this.fileInput.current.files[0];
        if (file) {
            this.setState({loading: true});
            this.readFileAsBase64(file).then((resolve, reject)=>{
                console.log(resolve);
                var fileContent = resolve.replace(/^data:.+;base64,/, '');
                if(this.props.linkID !== undefined && this.props.linkID !== null)
                {
                    uploadAttachment(this.state.description,this.props.linkType, this.props.linkID, file.name, fileContent).then((value)=>{
                        console.log(value);
                        this.setState({description: '', loading: false});
                        this.props.onClose();
                    });
                }
                else
                {
                    if(this.props.onSaveAttachmentWithoutLink != undefined)
                    {
                        uploadAttachmentWithoutLink(file.name, this.state.description, fileContent, localStorage.getItem('UserID'), new Date()).then(
                            (response) =>
                        {
                            if (response !== undefined) {
                                switch (response.httpStatusCode) {
                                    case 200: {
                                        this.props.onSaveAttachmentWithoutLink(response.id,file.name, this.state.description);
                                        this.setState({description: '', loading: false});
                                        this.props.onClose();
                                        break;
                                    }
                                    default: {
                                        this.setState({ alertMessage: 'Upload failed. Please try again.', showAlert: true, alertTitle: 'Error', loading:false });
                                        break;
                                    }
                                }
                            } else {
                                this.setState({ alertMessage: 'Upload failed. Please try again.', showAlert: true, alertTitle: 'Error' });
                            }
                        });
                    }
                    else
                    {
                        this.setState({ alertMessage: 'Please, first save the '+this.props.linkType, showAlert: true, alertTitle: 'Error' });                            
                    }
                }
             });
        }
        
    }

    dismissAlert = () => {
        this.setState({ showAlert: false });
    };

    readFileAsBase64(file){
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
    
            reader.onload = (event) => {
                resolve(event.target.result);
            };
    
            reader.onerror = (err) => {
                reject(err);
            };
    
            reader.readAsDataURL(file);
        });
    }

    render() {
        return(
            <div>
                <Dialog open={this.props.open} onClose={this.props.onClose}>
                    <DialogTitle>Upload Attachment</DialogTitle>
                    <DialogContent>
                    <div uk-form-custom="target: true" className="uk-margin file-box">
                        <Lottie animationData={uploadAnimation} style={{height: '200px'}}/>
                        <h5>Click or Drag&Drop the file you want to attach</h5>
                        <input type="file" ref={this.fileInput} className="file_upload"/>
                        <input className="uk-input uk-form-width-large" type="text" placeholder="Select a file..." disabled/>
                    </div>
                    
                    {/*<div className="uk-margin">
                        <div uk-form-custom="target: true" className="uk-form-controls">
                            
                        </div>
                    </div>*/}
                    <div className="uk-margin">
                        <label className="uk-form-label" htmlFor="form-attachment-description">Description</label>
                        <div className="uk-form-controls">
                            <input className="uk-input uk-form-width-large" id="form-attachment-description" type="text" placeholder="Description" value={this.state.description} onChange={this.getDescriptionValue.bind(this)}/>
                        </div>
                    </div>
                    </DialogContent>
                    <DialogActions>
                        <button className="uk-button uk-button-green" key={"cancel"} type="button" onClick={this.props.onClose}>Cancel</button>
                        <button className="uk-button uk-button-green" key={"upload"} type="button" onClick={this.handleUploadFile}>Upload</button>
                    </DialogActions>
                </Dialog>
                <LoadingBox loading={this.state.loading}/>
                <AlertBox
                    id="disbursement-dialog-alert"
                    open={this.state.showAlert}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    type="Ok"
                    okClick={this.dismissAlert}
                />
            </div>
        );
    }

}